import React from 'react';
import { createRoot } from 'react-dom/client';
import $ from 'jquery';
import StepQuestions from '../components/StepQuestions';

let node;
let props;

$.ajaxSetup({ cache: false });

document.addEventListener('DOMContentLoaded', () => {
  node = document.getElementById('step-questions-app');

  if (!node) {
    return;
  }

  props = {
    allowMessaging: node.dataset.allowMessaging === 'true',
    answerEndpoint: node.dataset.answerEndpoint,
    courseDir: node.dataset.courseDir,
    courseId: parseInt(node.dataset.courseId, 10),
    dir: node.dataset.dir,
    markCompleteEndpoint: node.dataset.markCompleteEndpoint,
    messageEndpoint: node.dataset.messageEndpoint,
    questionsEndpoint: node.dataset.questionsEndpoint,
    stepId: parseInt(node.dataset.stepId, 10),
    strings: {
      allQuestionsAnswered: node.dataset.stringAllQuestionsAnswered,
      cancel: node.dataset.stringCancel,
      continue: node.dataset.stringContinue,
      placeholder: node.dataset.stringPlaceholder,
      submit: node.dataset.stringSubmit,
      successMessage: node.dataset.stringSuccessMessage,
      thoughtQuestion: node.dataset.stringThoughtQuestion,
      trigger: node.dataset.stringTrigger,
      tryAgain: node.dataset.stringTryAgain,
    },
  };

  createRoot(node).render(<StepQuestions {...props} />);
});
